import { useApi } from '../instance';
import { ContactMessage, ContactMessageResponse } from './types';

export const useGetContactMe = () => {
  return useApi<ContactMessageResponse[]>(
    {
      url: 'contact-me',
      method: 'GET',
    },
    { manual: true },
  );
};

export const useSendMessage = () => {
  return useApi<{ success: boolean }, ContactMessage>(
    {
      url: 'contact-me',
      method: 'POST',
    },
    { manual: true },
  );
};

export const useMarkContactMeAsRead = () => {
  return useApi<{ success: boolean }, { id: string; is_read: boolean }>(
    {
      url: 'contact-me',
      method: 'PUT',
    },
    { manual: true },
  );
};
